import React from 'react';
import { Helmet } from 'react-helmet';
import ServicePage from '../components/ServicePage';
import html from '../content/aiReadinessAssessment.html.js';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';

export default function AIReadinessAssessment() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'AI Readiness Assessment Service',
    description:
      'Helping organisations build the foundations for successful, sustainable AI adoption.',
    url: canonicalUrl,
  };
  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>AI Readiness Assessment</title>
        <meta name="description" content="Assess your organisation's readiness for adopting AI technology." />
        <meta property="og:title" content="AI Readiness Assessment" />
        <meta property="og:description" content="Evaluate how prepared you are to implement AI successfully." />
        <meta property="og:image" content="/assets/visuals/re-back-matrix-coder.webp" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <ServicePage
        title="AI Readiness Assessment"
        tagline="Helping organisations build the foundations for successful, sustainable AI adoption."
        ctaText="Contact Us"
        ctaLink="/contact"
        htmlContent={html}
        imageSrc="/assets/visuals/re-back-matrix-coder.webp"
        imageAlt="AI readiness visual"
      />
    </>
  );
}
